import {
  ensureTab,
  getRows,
  sheetsRequest,
  appendRow,
  clearSheetsCache,
} from '../lib/googleSheets';

const TAB_NAME = 'Settings';
const HEADERS = ['id', 'key', 'value', 'updated_at'];

export const configService = {
  async getAll() {
    await ensureTab(TAB_NAME, HEADERS);

    const rows = await getRows(`${TAB_NAME}!A2:Z`);
    const config = {};

    rows.forEach((row) => {
      const key = String(row?.[1] ?? '').trim();

      if (key) {
        config[key] = row?.[2] ?? '';
      }
    });

    return config;
  },

  async bulkUpdate(settingsObject) {
    await ensureTab(TAB_NAME, HEADERS);

    const rows = await getRows(`${TAB_NAME}!A:Z`);
    const now = new Date().toISOString();
    const requests = [];

    for (const [key, value] of Object.entries(settingsObject)) {
      const rowIndex = rows.findIndex(
        (row, index) =>
          index > 0 &&
          String(row?.[1] ?? '').trim() === key
      );

      const id =
        rowIndex !== -1 && rows[rowIndex]?.[0]
          ? rows[rowIndex][0]
          : crypto.randomUUID();

      const rowData = [id, key, String(value ?? ''), now];

      if (rowIndex !== -1) {
        const sheetRow = rowIndex + 1;

        requests.push({
          range: `${TAB_NAME}!A${sheetRow}:Z${sheetRow}`,
          values: [rowData],
        });
      } else {
        await appendRow(`${TAB_NAME}!A:Z`, rowData);
      }
    }

    if (requests.length > 0) {
      await sheetsRequest('/values:batchUpdate', {
        method: 'POST',
        body: JSON.stringify({
          valueInputOption: 'USER_ENTERED',
          data: requests,
        }),
      });
    }

    clearSheetsCache();
    return true;
  },
};